import {Button} from "@zendeskgarden/react-buttons";
import {Body, Close, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {Input} from "@zendeskgarden/react-forms";
import {ReactElement, useState} from "react";
import * as css from "./confirmation-modal.module.scss";

export type ConfirmationModalProps = {
    onAccept: () => void;
    onCancel: () => void;
    header: string;
    message: string;
    confirmationText: string;
};

export default function ConfirmationModal({onAccept, onCancel, header, message, confirmationText}: ConfirmationModalProps): ReactElement {
    const [inputVal, setInputVal] = useState("");

    return (
        <Modal onClose={onCancel} className={css.wrapper}>
            <Header isDanger className={css.header}>
                {header}
            </Header>
            <Body>
                <p>
                    {message}
                </p>
                <h5>Enter "{confirmationText}" to confirm.</h5>
                <Input
                    type="text"
                    aria-label={`Enter "${confirmationText}" to confirm.`}
                    placeholder={confirmationText}
                    value={inputVal}
                    onChange={(e) => setInputVal(e.target.value)}
                />
                <div className={css.warningWrapper}>
                    <h5 className={css.warningText}>THIS ACTION CANNOT BE UNDONE</h5>
                </div>
            </Body>
            <Footer>
                <FooterItem>
                    <Button onClick={onCancel} isBasic>
                        Cancel
                    </Button>
                </FooterItem>
                <FooterItem>
                    <Button
                        isPrimary
                        isDanger
                        onClick={onAccept}
                        disabled={inputVal !== confirmationText}
                    >
                        Save Changes
                    </Button>
                </FooterItem>
            </Footer>
            <Close aria-label="Close modal" />
        </Modal>
    );
}
